__turbopack_context__.v({
  "Separator": "ContributionsList-module-scss-module__9SfxtG__Separator",
  "connectButton": "ContributionsList-module-scss-module__9SfxtG__connectButton",
  "currentProjectBadge": "ContributionsList-module-scss-module__9SfxtG__currentProjectBadge",
  "details": "ContributionsList-module-scss-module__9SfxtG__details",
  "editBtn": "ContributionsList-module-scss-module__9SfxtG__editBtn",
  "emptyData": "ContributionsList-module-scss-module__9SfxtG__emptyData",
  "expItem": "ContributionsList-module-scss-module__9SfxtG__expItem",
  "label": "ContributionsList-module-scss-module__9SfxtG__label",
  "list": "ContributionsList-module-scss-module__9SfxtG__list",
  "logo": "ContributionsList-module-scss-module__9SfxtG__logo",
  "primaryLabel": "ContributionsList-module-scss-module__9SfxtG__primaryLabel",
  "root": "ContributionsList-module-scss-module__9SfxtG__root",
  "row": "ContributionsList-module-scss-module__9SfxtG__row",
  "secondaryLabel": "ContributionsList-module-scss-module__9SfxtG__secondaryLabel",
});
